





































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import CustomAttributeAddModal from '@/components/taskList/customAttributeAddModal/CustomAttributeAddModalBase.vue';
import {
  Project,
  UpdateProjectTaskAttributeValueOptionsParam,
  AttributeCd,
  UpdateProjectCustomAttributesParam,
  UpdateTaskAttributeValueOptionsQuery,
} from '@/@types/Project';
import { UpdateModeQueryDto, valueof } from '@/@types/Common';
import { AttributeName, ColumnSwitch, CustomAttribute, DefaultTaskTableAttributes, TaskAttribute } from '@/@types/LibraryComponent';
import { vxm } from '@/store';
import { ATTRIBUTE_STYLE } from '@/@types/constant';

@Component({
  components: {
    CustomAttributeAddModal,
  },
})
export default class TaskListTableHeader extends Vue {
  @Prop()
  public columnSwitch!: Array<{ icon: string; text: string; boolean: boolean }>;
  @Prop()
  private customAttributes!: CustomAttribute[];
  @Prop()
  private fieldColumns!: ColumnSwitch[];
  private customAttributeIndex: number = 0;
  private isOpenCustomAttributeAddModal: boolean = false;
  /** widthの参考に残しておく */
  private taskListHeaders: Array<{ text: string; value: string; width: string }> = [
    { text: '課題ID', value: 'id', width: '90px' },
    { text: '課題タイトル', value: 'title', width: '500px' },
    { text: 'カテゴリー', value: 'category', width: '100px' },
    { text: '担当者', value: 'representative', width: '150px' },
    { text: '優先度', value: 'priority', width: '100px' },
    { text: 'ステータス', value: 'status', width: '150px' },
    { text: '作業担当者', value: 'worker', width: '150px' },
    { text: '開始日', value: 'startDate', width: '150px' },
    { text: '期限日', value: 'deadLine', width: '150px' },
    { text: '予定', value: 'schedule', width: '50px' },
    { text: '実績', value: 'performance', width: '50px' },
  ];

  /** デフォルト属性とカスタム属性を合わせてTaskAttribute[]型を作成 */
  private taskTableAttributes() {
    let attributes: TaskAttribute[] = [];
    const taskIdAttribute: TaskAttribute = {
      attribute: AttributeName.taskId,
      attributeKey: '',
      attributeNumber: null,
      style: null,
      displayStyle: null,
      displayFlag: true,
      value: null,
      customFlag: false,
    };
    attributes.push(taskIdAttribute);
		attributes = attributes.concat(DefaultTaskTableAttributes);
    /** カスタム属性を取得 */
    if (this.customAttributes.length > 0) {
      this.customAttributes.forEach((attribute) => {
        /** カスタム属性を識別する数字 */
        const index = attribute.attributeNumber;
        let value: string | number | Date | null = null;
        let attributeKey: string = '';
        /** 属性の形式から、カスタム属性値を取得する */
        switch (attribute.style) {
          /** 日付形式 */
          case ATTRIBUTE_STYLE.DATE:
            attributeKey = `customAttribute${index}ValueDate`;
            break;
          /** 人物形式 */
          case ATTRIBUTE_STYLE.PERSON:
            attributeKey = `customAttribute${index}ValuePerson`;
            break;
          /** テキスト形式 */
          case ATTRIBUTE_STYLE.TEXT:
            attributeKey = `customAttribute${index}ValueText`;
            break;
          /** 選択肢形式 */
          case ATTRIBUTE_STYLE.OPTION:
            attributeKey = `customAttribute${index}ValueOption`;
            break;
          /** 数値形式 */
          case ATTRIBUTE_STYLE.NUMBER:
            attributeKey = `customAttribute${index}ValueNumber`;
            break;
          default:
            break;
        }
        /** デフォルト属性の配列に結合するためのカスタム属性 */
        const customAttribute: TaskAttribute = {
          attribute: attribute.name,
          attributeKey: attributeKey,
          attributeNumber: attribute.attributeNumber,
          style: attribute.style,
          displayStyle: attribute.displayStyle,
          displayFlag: attribute.displayFlag,
          value: value,
          customFlag: true,
        };
        attributes.push(customAttribute);
      });
    }
    return attributes;
  }

  private openCustomAttributeAddModal(): void {
    /** プロジェクトのプロパティからカスタム属性名称のみ取得 */
    if (this.project) {
      const keys = Object.keys(this.project).filter((key) => {
      return key.substr(0, 6) === 'custom' && key.substr(-4, 4) === 'Name';
    });
    /** プロジェクトの全カスタム属性のうち、値がnullである最初の属性の数字を取得 */
    const attributeIndex =
      keys.findIndex((key, index) => {
        const number = index + 1;
        return (
          !this.project[`customAttribute${number}Name`] &&
          !this.project[`customAttribute${number}Style`] &&
          !this.project[`customAttribute${number}DisplayStyle`] &&
          !this.project[`customAttribute${number}DisplayFlag`]
        );
      }) + 1;
    this.customAttributeIndex = attributeIndex;
    this.isOpenCustomAttributeAddModal = true;
    }
  }

  private closeCustomAttributeAddModal(): void {
    this.isOpenCustomAttributeAddModal = false;
  }

  /** プロジェクトカスタム属性更新API実行 */
  private async updateProjectCustomAttributes(
    param: UpdateProjectCustomAttributesParam,
  ) {
    const query: UpdateModeQueryDto = {
      'update-mode': 'part',
    };
    await vxm.theoryApi.projectsStore.updateProjectCustomAttributes({
      projectId: this.projectId,
      param: param,
      query: query,
    });
    this.closeCustomAttributeAddModal();
    this.emitCloseCustomAttributeAddModal();
    return;
  }

  /** 課題属性値選択項目更新API実行 */
  private async updateProjectTaskAttributeValueOptions(params: {
    param: UpdateProjectTaskAttributeValueOptionsParam;
    query: valueof<keyof typeof AttributeCd>[];
  }) {
    const query: UpdateTaskAttributeValueOptionsQuery = {
      'update-mode': 'all',
      'attribute-code': params.query,
    };
    await vxm.theoryApi.projectsStore.updateProjectTaskAttributeValueOptions({
      projectId: this.projectId,
      param: params.param,
      query: query,
    });
    this.closeCustomAttributeAddModal();
    this.emitCloseCustomAttributeAddModal();
    return;
  }

  @Emit('emitCustomAttributeAddModal')
  private emitCloseCustomAttributeAddModal() {
    return;
  }

  private get project(): Project | undefined {
    const response = vxm.theoryApi.projectsStore.getProject;
    if (response) {
      return response.results;
    } else undefined;
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId;
  }

  private get taskAttributeValueOptions(): TaskAttributeValueOption[] {
    const response = vxm.theoryApi.projectsStore.getTaskAttributeValueOptions;
    if (response) {
      return response.results;
    } else return [];
  }
}
